module.exports = __webpack_public_path__ + "static/media/Logo_territory_mmc.fe0fd927.png";